import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import authService from '../../../services/auth.service';
import { buildWalletBucket, resetWalletBucket, setWalletCookies } from '../../../system/utils/walletUtils';
import * as Wallet from '../../../wallet/api';
import { getMe } from '../App/appSlice';
import { setNeedUpdateGuild } from '../Guild/slice';
export const connectWallet = createAsyncThunk('/wallet/connect', async ({ name, accessToken, refreshToken }, { dispatch }) => {
    const walletInfo = await Wallet.getWalletInfo(name);
    const data = Object.assign(Object.assign({}, walletInfo), { name });
    setWalletCookies(name, walletInfo.stakeId, accessToken, refreshToken);
    dispatch(getMe());
    dispatch(setNeedUpdateGuild());
    return { data };
});
export const authenticateWallet = createAsyncThunk('/wallet/authenticate', async ({ walletName }, { dispatch }) => {
    const valid = await authService.authenticateWallet(walletName);
    if (!valid)
        return;
    const { accessToken, refreshToken } = valid;
    dispatch(connectWallet({ name: walletName, accessToken, refreshToken }));
    return valid;
});
export const buildWalletsBucketThunk = createAsyncThunk('/wallet/build', async ({ walletItems, cookies }) => {
    const data = await buildWalletBucket(walletItems, cookies);
    return data;
});
export const resetWalletsBucketThunk = createAsyncThunk('/wallet/reset', async (walletItems) => {
    const data = await resetWalletBucket(walletItems);
    return data;
});
export const refreshToken = createAsyncThunk('/wallet/refresh', async (refreshToken) => {
    const { data } = await authService.refresh(refreshToken);
    if (!data)
        return;
    return data;
});
export const initialState = {
    activeWallet: {
        isConnected: false
    },
    walletsBucket: [],
    walletsUpdating: false
};
const slice = createSlice({
    name: 'wallet',
    initialState,
    reducers: {
        clearWalletData: (state) => {
            state.activeWallet = {};
        }
    },
    extraReducers(builder) {
        builder.addCase(connectWallet.fulfilled, (state, { payload }) => {
            state.activeWallet = {
                name: payload.data.name,
                isConnected: true,
                address: payload.data.stakeId,
                balance: (Number(payload.data.coins) / 1000000).toFixed(2).toString(),
                walletInfo: payload.data
            };
        });
        builder.addCase(buildWalletsBucketThunk.pending, (state, { payload }) => {
            state.walletsUpdating = true;
        });
        builder.addCase(buildWalletsBucketThunk.fulfilled, (state, { payload }) => {
            state.walletsUpdating = false;
            state.walletsBucket = payload;
        });
        builder.addCase(buildWalletsBucketThunk.rejected, (state, { payload }) => {
            state.walletsUpdating = false;
        });
        builder.addCase(resetWalletsBucketThunk.pending, (state, { payload }) => {
            state.walletsUpdating = true;
        });
        builder.addCase(resetWalletsBucketThunk.fulfilled, (state, { payload }) => {
            state.walletsUpdating = false;
            state.walletsBucket = payload;
        });
        builder.addCase(resetWalletsBucketThunk.rejected, (state, { payload }) => {
            state.walletsUpdating = false;
        });
    }
});
export const { clearWalletData } = slice.actions;
export default slice.reducer;
